import { API_ENDPOINTS, BACKEND_API_URL } from './endpoints';

/**
 * Number of top validators (by voting power) excluded from delegating and
 * claiming via this interface. Users must redelegate away from these validators
 * to promote decentralization of the validator set.
 */
export const EXCLUDED_TOP_VALIDATORS_COUNT = 2;

/**
 * Delegations below this threshold (in GRAV) to an excluded top validator are
 * treated as dust and do NOT block claim-all or trigger the alarm banner.
 * This prevents users from getting stuck when they cannot fully close a position.
 */
export const EXCLUDED_VALIDATOR_DUST_THRESHOLD_GRAV = 1000;

// Frontend constants fetched from backend
export interface AppConstants {
  gravityGrpc: string;
  gravityRest: string;
  gravityRpc: string;
  gravityChainId: string;
  ethRpc: string;
  gravityContract: string;
}

let cachedConstants: AppConstants | null = null;

export async function getConstants(): Promise<AppConstants> {
  if (cachedConstants !== null) {
    return cachedConstants;
  }

  const url = `${BACKEND_API_URL}${API_ENDPOINTS.CONSTANTS}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch constants from ${url}: ${response.statusText}`);
  }

  const constants = (await response.json()) as AppConstants;
  cachedConstants = constants;
  return constants;
}

export function getCachedConstants(): AppConstants | null {
  return cachedConstants;
}
